import {
  FilterFieldDef,
  OPS_DATE_FULL,
  OPS_LIST,
  OPS_NUM_FULL,
  OPS_TEXT_CONTAINS,
  OPS_TEXT_FULL,
  OPS_TEXT_ID,
} from '../../../components/molecules/FilterBar';

export const SHIPMENT_FILTER_FIELD_DEFINITIONS: FilterFieldDef[] = [
  // ── Shipment ────────────────────────────────────────────────
  { name: 'Shipment ID', key: 'id', type: 'text', category: 'Shipment', operators: OPS_TEXT_ID },
  {
    name: 'Type',
    key: 'shipmentTypeCode',
    type: 'list',
    category: 'Shipment',
    operators: OPS_LIST,
  },
  {
    name: 'Status',
    key: 'shipmentStatusCode',
    type: 'list',
    category: 'Shipment',
    operators: OPS_LIST,
  },
  {
    name: 'Client/Contract',
    key: 'clientContractNames',
    type: 'text',
    category: 'Shipment',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Notes',
    key: 'notes',
    type: 'text',
    category: 'Shipment',
    operators: OPS_TEXT_CONTAINS,
  },

  // ── Source & Destination ────────────────────────────────────
  {
    name: 'Source',
    key: 'sourceName',
    type: 'text',
    category: 'Source & Destination',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Source Node Type',
    key: 'sourceNodeType',
    type: 'list',
    category: 'Source & Destination',
    operators: OPS_LIST,
  },
  {
    name: 'Destination',
    key: 'destinationName',
    type: 'text',
    category: 'Source & Destination',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Destination Node Type',
    key: 'destinationNodeType',
    type: 'list',
    category: 'Source & Destination',
    operators: OPS_LIST,
  },

  // ── Freight ─────────────────────────────────────────────────
  {
    name: 'Courier Name',
    key: 'courierName',
    type: 'text',
    category: 'Freight',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Connote No.',
    key: 'connoteNo',
    type: 'text',
    category: 'Freight',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Latest Tracking Event',
    key: 'latestTrackingStatus',
    type: 'text',
    category: 'Freight',
    operators: OPS_TEXT_CONTAINS,
  },
  {
    name: 'Expected Arrival Date',
    key: 'arrivalDate',
    type: 'date',
    category: 'Freight',
    operators: OPS_DATE_FULL,
  },
  {
    name: 'Shipping Cost',
    key: 'shippingCost',
    type: 'number',
    category: 'Freight',
    operators: OPS_NUM_FULL,
  },

  // ── References ──────────────────────────────────────────────
  {
    name: 'Reference 1',
    key: 'referenceNumber1',
    type: 'text',
    category: 'References',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Reference 2',
    key: 'referenceNumber2',
    type: 'text',
    category: 'References',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Reference 3',
    key: 'referenceNumber3',
    type: 'text',
    category: 'References',
    operators: OPS_TEXT_FULL,
  },

  // ── Totals ──────────────────────────────────────────────────
  {
    name: 'Quantity Total',
    key: 'qtyTotal',
    type: 'number',
    category: 'Totals',
    operators: OPS_NUM_FULL,
  },
  {
    name: 'Quantity Received',
    key: 'qtyReceived',
    type: 'number',
    category: 'Totals',
    operators: OPS_NUM_FULL,
  },
  {
    name: 'Quantity Pending',
    key: 'qtyPending',
    type: 'number',
    category: 'Totals',
    operators: OPS_NUM_FULL,
  },

  // ── Audit ───────────────────────────────────────────────────
  {
    name: 'Created At',
    key: 'createdAt',
    type: 'date',
    category: 'Audit',
    operators: OPS_DATE_FULL,
  },
  {
    name: 'Created By',
    key: 'createdByName',
    type: 'text',
    category: 'Audit',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Updated At',
    key: 'updatedAt',
    type: 'date',
    category: 'Audit',
    operators: OPS_DATE_FULL,
  },
  {
    name: 'Updated By',
    key: 'updatedByName',
    type: 'text',
    category: 'Audit',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Completed At',
    key: 'completedAt',
    type: 'date',
    category: 'Audit',
    operators: OPS_DATE_FULL,
  },
];

export const SHIPMENT_FILTER_CATEGORIES = [
  'All',
  'Shipment',
  'Source & Destination',
  'Freight',
  'References',
  'Totals',
  'Audit',
];
